module.exports = __webpack_public_path__ + "img/falcimg.13638e2d.png";